export const AddressNewOptionId = -1;
